module.exports = __webpack_public_path__ + "static/media/vlogo.9da5c4fd.png";